import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
    fetchEstadosLiquidaciones,
    fetchLiquidacionesBusqueda,
    limpiarLiquidacionesBusqueda,
    setFiltroLiquidaciones
} from '../../../../actions/LiquidacionesActions';
import {
    getEstadosLiquidacionesCorrecto,
    putEliminaLiquidacionFinal,
    listSellers
} from '../../../../api/axios.js';
import { fetchSellersFilter } from '../../../../actions/sellersActions';
import LiquidacionesListItems from './LiquidacionesListItems';
import { customStyleFilter, DropDownArrow } from "../../../../template/CustomStyle";
import { toast } from 'react-toastify';
import Select from 'react-select';
import { fechaLimite, filtroMedioMes } from '../../../../utilities/fechasFiltro';
import { limpiarFiltros } from '../../../../actions/generalActios.js';
import BigSpinner from '../../../General/BigSpinner.js';
import ReactPaginate from 'react-paginate';

// Wrapper para usar hooks en class component
function ListLiquidacionesWrapper(props) {
    const navigate = useNavigate();
    return <ListLiquidaciones {...props} navigate={navigate} />;
}

const fechaFiltro = filtroMedioMes();
const fechaDesdeMinima = fechaLimite();

class ListLiquidaciones extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pageSize: 10,
            lista_estados_liquidaciones: [],
            seller: {
                label: this.props.filtro?.seller?.label ?? "",
                value: this.props.filtro?.seller?.value ?? ""
            },
            estado: {
                label: this.props.filtro?.estado?.label ?? "",
                value: this.props.filtro?.estado?.value ?? ""
            },
            fechaDesde: this.props.filtro?.fechaDesde ?? fechaFiltro.desde,
            fechaHasta: this.props.filtro?.fechaHasta ?? fechaFiltro.hasta,
            buscaTodo: this.props.filtro?.buscaTodo ?? true,
            idLiquidacion:
                this.props.filtro?.idLiquidacion != null && this.props.filtro?.idLiquidacion !== ''
                    ? String(this.props.filtro.idLiquidacion)
                    : '',
        };
        this.INITIAL_REQUEST = {
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            seller: { label: "", value: "" },
            estado: { label: "", value: "" },
            numeroPagina: 1,
            tamanoPagina: 10,
            idLiquidacion: '',
        };
    };

    parseIdLiquidacion = (raw) => {
        const s = String(raw ?? '').trim();
        if (!s) return null;
        const n = parseInt(s, 10);
        return Number.isNaN(n) || n < 1 ? null : n;
    };

    buildLiquidacionesBusquedaRequest = (numeroPagina) => {
        const { fechaDesde, fechaHasta, seller, estado } = this.state;
        const { tipoUsuario, idSeller, filtro } = this.props;
        const isAuthorizedViewAll = tipoUsuario === 1 || tipoUsuario === 2 || tipoUsuario === 8;
        const page = numeroPagina ?? filtro?.numeroPagina ?? 1;
        const tamanoPagina = this.state.pageSize;
        const idLiq = this.parseIdLiquidacion(this.state.idLiquidacion);

        if (!isAuthorizedViewAll) {
            const r = {
                fechaDesde,
                fechaHasta,
                idEstado: 3,
                idSeller: filtro?.seller ?? idSeller,
                numeroPagina: page,
                tamanoPagina
            };
            if (idLiq != null) r.idLiquidacion = idLiq;
            return r;
        }

        const request = { fechaDesde, fechaHasta, numeroPagina: page, tamanoPagina };
        if (idLiq != null) {
            request.idLiquidacion = idLiq;
        } else {
            const sellerVacio = !seller.value;
            const estadoVacio = !estado.value;
            if (!sellerVacio || !estadoVacio) {
                Object.assign(request, {
                    idSeller: seller.value,
                    idEstado: estado.value,
                });
            }
        }
        return request;
    };

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        const request = this.buildLiquidacionesBusquedaRequest(selectedPage);
        this.props.setFiltroLiquidaciones({
            ...this.props.filtro,
            fechaDesde: this.state.fechaDesde,
            fechaHasta: this.state.fechaHasta,
            seller: this.state.seller,
            estado: this.state.estado,
            idLiquidacion: this.state.idLiquidacion,
            numeroPagina: selectedPage,
            tamanoPagina: this.state.pageSize
        });
        this.props.fetchLiquidacionesBusqueda(request);
    };

    componentDidMount() {
        if (this.props.liquidaciones?.length > 0) {
            return;
        }

        const isAuthorizedViewAll = this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2 || this.props.tipoUsuario === 8;

        if (!isAuthorizedViewAll) {

            let filtroParams = {
                fechaDesde: this.state.fechaDesde,
                fechaHasta: this.state.fechaHasta,
                idEstado: 3,
                idSeller: this.props.idSeller,
                numeroPagina: 1,
                tamanoPagina: this.state.pageSize,
            }

            this.props.fetchLiquidacionesBusqueda(filtroParams);

        } else {
            if (this.props.isFilterClear) {
                this.buscarSinFiltro();
            } else {
                this.buscarConFiltro();
            }
        }
    }

    buscarSinFiltro = () => {
        const isAuthorizedViewAll = this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2 || this.props.tipoUsuario === 8;

        if (!isAuthorizedViewAll) {
            let request = {
                fechaDesde: this.INITIAL_REQUEST.fechaDesde,
                fechaHasta: this.INITIAL_REQUEST.fechaHasta,
                idEstado: 3, //harcodeado para Liquidada
                idSeller: this.props.idSeller, // Force own seller
                numeroPagina: 1,
                tamanoPagina: this.state.pageSize,
            }
            this.props.fetchLiquidacionesBusqueda(request);
        } else {
            const req = {
                fechaDesde: this.INITIAL_REQUEST.fechaDesde,
                fechaHasta: this.INITIAL_REQUEST.fechaHasta,
                numeroPagina: 1,
                tamanoPagina: this.state.pageSize,
            };
            this.props.fetchLiquidacionesBusqueda(req);
            this.props.setFiltroLiquidaciones({ ...this.INITIAL_REQUEST, numeroPagina: 1, tamanoPagina: this.state.pageSize });
        }
    }

    buscarConFiltro = () => {
        let filtroParams = {
            fechaDesde: this.props.filtro.fechaDesde,
            fechaHasta: this.props.filtro.fechaHasta,
            idSeller: this.props.filtro.seller ?? this.props.idSeller,
            estado: this.props.filtro.estados,
            idLiquidacion: this.props.filtro.idLiquidacion,
            numeroPagina: this.props.filtro.numeroPagina ?? 1,
            tamanoPagina: this.props.filtro.tamanoPagina ?? this.props.filtro.cantidadPagina ?? this.state.pageSize,
        }

        this.props.fetchLiquidacionesBusqueda(filtroParams);

        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, liquidaciones: false });
    }

    onLiquidacion = (idSeller, idLiquidacion) => {
        this.props.navigate(`/Liquidaciones/Editar/${idLiquidacion}/${idSeller}`);
    }

    onLiquidacionEditable = (idSeller, idLiquidacion) => {
        this.props.navigate(`/Liquidaciones/EditarBorrador/${idLiquidacion}/${idSeller}`);
    }

    goToCrearLiquidacion = () => {
        this.props.navigate("/Liquidaciones/Nueva");
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onChangeCheckbox = async (e) => {
        const { name, checked } = e.target;
        this.setState({ [name]: checked });

        this.props.setFiltroLiquidaciones({
            ...this.props.filtroLiquidaciones,
            [name]: checked
        });
    }

    eliminarLiquidacion = (idLiquidacion) => {

        let request = { IdLiquidacion: idLiquidacion };
        let post = putEliminaLiquidacionFinal(request);

        post.then(res => {
            document.getElementById("botonBuscar").click();
            toast.success("La liquidación fue eliminada con éxito");
        }).catch(err => {
            toast.error("No pudimos eliminar la liquidación");
        });
    }

    onSubmit = (event) => {
        event.preventDefault();

        const { fechaDesde, fechaHasta, buscaTodo, seller = {}, estado = {}, idLiquidacion } = this.state;
        const { tipoUsuario, filtro, idSeller } = this.props;

        const isAuthorizedViewAll = tipoUsuario === 1 || tipoUsuario === 2 || tipoUsuario === 8;
        const idLiq = this.parseIdLiquidacion(idLiquidacion);

        // Caso para usuarios restringidos (solo ven lo suyo)
        if (!isAuthorizedViewAll) {
            const request = {
                fechaDesde,
                fechaHasta,
                idEstado: 3, // hardcodeado para Liquidada
                idSeller: filtro?.seller ?? idSeller,
                numeroPagina: 1,
                tamanoPagina: this.state.pageSize,
            };
            if (idLiq != null) request.idLiquidacion = idLiq;

            this.props.limpiarLiquidacionesBusqueda();
            this.props.setFiltroLiquidaciones({
                fechaDesde,
                fechaHasta,
                seller,
                estado,
                idLiquidacion: idLiquidacion ?? '',
                numeroPagina: 1,
                tamanoPagina: this.state.pageSize,
            });
            this.props.fetchLiquidacionesBusqueda(request);
            this.setLimpiarFiltroFalse();
            return;
        }

        // Sin ID liquidación: fechas obligatorias
        if (idLiq == null) {
            if (!fechaDesde) {
                toast.warn("Debe seleccionar una fecha inicial");
                return;
            }
            if (!fechaHasta) {
                toast.warn("Debe seleccionar una fecha final");
                return;
            }
        }

        // Actualizar filtro global
        const setFiltroParams = {
            fechaDesde,
            fechaHasta,
            seller,
            estado,
            idLiquidacion: idLiquidacion ?? '',
            numeroPagina: 1,
            tamanoPagina: this.state.pageSize,
        };
        this.props.setFiltroLiquidaciones(setFiltroParams);

        const request = {
            numeroPagina: 1,
            tamanoPagina: this.state.pageSize,
        };
        if (idLiq != null) {
            request.idLiquidacion = idLiq;
            if (fechaDesde) request.fechaDesde = fechaDesde;
            if (fechaHasta) request.fechaHasta = fechaHasta;
        } else {
            request.fechaDesde = fechaDesde;
            request.fechaHasta = fechaHasta;
            const sellerVacio = !seller.value;
            const estadoVacio = !estado.value;
            if (!sellerVacio || !estadoVacio) {
                Object.assign(request, {
                    idSeller: seller.value,
                    idEstado: estado.value,
                });
            }
        }

        this.props.limpiarLiquidacionesBusqueda();
        this.props.fetchLiquidacionesBusqueda(request);
        this.setLimpiarFiltroFalse();
    };


    onClear = (e) => {
        e.preventDefault();
        this.setState(prevState => ({
            ...prevState,
            ...this.INITIAL_REQUEST
        }));
        this.buscarSinFiltro();
    };

    selectSearchHandlerLiquidacionesSeller = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ seller: valor });
    }

    selectSearchHandlerLiquidacionesEstado = (options) => {
        let valor = { label: options.label, value: options.value.toString() };
        this.setState({ estado: valor });
    }

    mapSellers = () => {
        this.props.fetchSellersFilter({
            Descripcion: "",
            Page: 1,
            PageSize: 100
        });
    }

    onSelectSearchInputSellers = (descripcion, action) => {
        if (action.action === 'input-change') {
            this.props.fetchSellersFilter({
                Descripcion: descripcion,
                Page: 1,
                PageSize: 100
            });
        }
    }

    mapEstados = () => {

        getEstadosLiquidacionesCorrecto().then(res_estados => {
            let listaEstado = res_estados.listadoEstadosLiquidaciones.map((tipo) => {
                return { label: tipo.descripcion, value: tipo.idEstado.toString() };
            })
            this.setState({
                lista_estados_liquidaciones: listaEstado
            })
        });
    }

    render() {
        let liquidaciones = !Array.isArray(this.props.liquidaciones) ? [] : this.props.liquidaciones;
        const isAuthorizedViewAll = this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2 || this.props.tipoUsuario === 8;
        const listaSellers = Array.isArray(this.props.filteredSellers)
            ? this.props.filteredSellers.map(s => ({ label: s.label, value: s.value.toString() }))
            : [];

        return (
            <div className="container">
                <div className="row justify-content-between">

                    <div className="col-12 col-md-4">
                        <h4 className="text-themecolor color-rojo-megatone">Gestión de Liquidación</h4>
                    </div>

                    {isAuthorizedViewAll && (
                        <div className="col-12 col-md-2 text-end">
                            <button
                                onClick={this.goToCrearLiquidacion}
                                type="button"
                                className="btn btn-sm btn-green"
                            >
                                <i className="fa fa-plus-circle" /> Crear Liquidación
                            </button>
                        </div>
                    )}

                    <form className="form-horizontal form-material p-10" onSubmit={this.onSubmit} onReset={this.onClear}>
                        <div className="card filter-card">
                            <div className="card-body p-4">

                                <div className="row justify-content-between">
                                    <div className="col-12 col-md-2 d-inline-block">

                                        <p className="font-bold">Desde</p>
                                        <input
                                            type="date"
                                            name="fechaDesde"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            min={fechaDesdeMinima}
                                            value={this.state.fechaDesde}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 d-inline-block">
                                        <p className="font-bold">Hasta</p>
                                        <input
                                            type="date"
                                            name="fechaHasta"
                                            className="form-control"
                                            onChange={this.myChangeHandler}
                                            min={this.state.fechaDesde}
                                            value={this.state.fechaHasta}
                                        />
                                    </div>

                                    <div className="col-12 col-md-2 d-inline-block">
                                        <p className="font-bold">N° liquidación</p>
                                        <input
                                            type="text"
                                            name="idLiquidacion"
                                            className="form-control"
                                            autoComplete="off"
                                            inputMode="numeric"
                                            onChange={this.myChangeHandler}
                                            value={this.state.idLiquidacion}
                                        />
                                    </div>

                                    {isAuthorizedViewAll && (
                                        <div className="col-12 col-md-2 d-inline-block">

                                            <p className="font-bold">Seller</p>
                                            <Select
                                                value={this.state.seller}
                                                options={listaSellers}
                                                onChange={this.selectSearchHandlerLiquidacionesSeller}
                                                onMenuOpen={this.mapSellers}
                                                onInputChange={this.onSelectSearchInputSellers}
                                                styles={customStyleFilter}
                                                components={{ DropdownIndicator: () => DropDownArrow }}
                                            />
                                        </div>
                                    )}

                                    {isAuthorizedViewAll && (
                                        <div className="col-12 col-md-2 d-inline-block">

                                            <p className="font-bold">Estados</p>
                                            <Select
                                                value={this.state.estado}
                                                options={this.state.lista_estados_liquidaciones}
                                                onChange={this.selectSearchHandlerLiquidacionesEstado}
                                                onMenuOpen={this.mapEstados}
                                                styles={customStyleFilter}
                                                components={{ DropdownIndicator: () => DropDownArrow }}
                                            />
                                        </div>
                                    )}

                                    <div className="col-12 col-sm-6 text-center text-sm-end mt-sm-3">
                                        <button
                                            type="submit"
                                            id="botonBuscar"
                                            className="btn btn-sm background-rojo-megatone"
                                            disabled={this.props.isLoadingLiquidaciones}
                                        >
                                            Buscar
                                        </button>

                                        <button
                                            type="reset"
                                            id="botonReset"
                                            className="btn btn-sm btn-grey ms-2 ms-sm-2 mt-2 mt-sm-0"
                                            disabled={this.props.isLoadingLiquidaciones}
                                        >
                                            Limpiar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <div hidden={!this.props.isLoadingLiquidaciones}>
                        <BigSpinner />
                    </div>

                    <div className="container" hidden={this.props.isLoadingLiquidaciones}>
                        {
                            liquidaciones.length === 0 ?

                                <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                                    NO SE ENCONTRARON RESULTADOS
                                </h5>

                                :

                                <LiquidacionesListItems
                                    liquidaciones={liquidaciones}
                                    onLiquidacionFunction={this.onLiquidacion}
                                    onLiquidacionEditableFunction={this.onLiquidacionEditable}
                                    eliminarLiquidacionFunction={this.eliminarLiquidacion}
                                />
                        }
                    </div>

                    {liquidaciones.length > 0 && Math.ceil((this.props.cantidadTotalLiquidacionesBusqueda || 0) / this.state.pageSize) > 1 && (
                        <div className="d-flex justify-content-center mt-3">
                            <ReactPaginate
                                previousLabel={"Anterior"}
                                nextLabel={"Siguiente"}
                                breakLabel={"..."}
                                breakClassName={"break-me"}
                                pageCount={Math.ceil((this.props.cantidadTotalLiquidacionesBusqueda || 0) / this.state.pageSize)}
                                marginPagesDisplayed={2}
                                pageRangeDisplayed={5}
                                onPageChange={this.handlePageClick}
                                containerClassName={"pagination"}
                                subContainerClassName={"pages pagination"}
                                activeClassName={"active"}
                                forcePage={(this.props.filtro?.numeroPagina ?? 1) - 1}
                            />
                        </div>
                    )}

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    tipoUsuario: state.general.tipoUsuario,
    isLoadingLiquidaciones: state.liquidaciones.isLoadingLiquidaciones,
    liquidaciones: state.liquidaciones.lista_liquidaciones_busqueda,
    cantidadTotalLiquidacionesBusqueda: state.liquidaciones.cantidadTotalLiquidacionesBusqueda,
    filteredSellers: state.sellers.filteredSellers,
    lista_estados_liquidaciones: state.liquidaciones.lista_estados_liquidaciones,
    filtro: state.liquidaciones.filtro,
    isFilterClear: state.general.limpiar.liquidaciones,
    emptyFilters: state.general.limpiar,
    idSeller: state.general.idSeller,
});

export default connect(mapStateToProps, {
    fetchSellersFilter,
    limpiarLiquidacionesBusqueda,
    fetchLiquidacionesBusqueda,
    fetchEstadosLiquidaciones,
    setFiltroLiquidaciones,
    limpiarFiltros
})(ListLiquidacionesWrapper);
